<template>
  <div class="homePage">
    <Modal v-if="centerVos.length > 1"  class="homePageModal" title="选择影像中心" v-model="showSelectWorkPlace" cancelText="退出登录" okText="确认" @ok="selectCenter" @cancel="logoutHandle">
      <RadioGroup v-model="selectCenterId">
        <div style="margin-bottom: 15px" v-for="item in centerVos" :key="item.id">
          <Radio :value="item.id">{{item.name}}</Radio>
        </div>
      </RadioGroup>
    </Modal>
  </div>
</template>
<script>
import { Modal, Radio } from 'ant-design-vue'
import { getLocal } from '../../libs/utils'
import { LoginUser, SelectCenter } from '../../libs/mixin'
export default {
  mixins: [LoginUser, SelectCenter],
  components: {
    Modal,
    Radio,
    RadioGroup: Radio.Group
  },
  mounted () {
    let centerVos = this.centerVos || []
    if (centerVos.length <= 0) return this.redirectWorkPlace()
    if (centerVos && centerVos.length === 1) return this.setCenter(centerVos[0])
    let lastCenter = getLocal('lastCenter', 'object') || null
    this.showSelectWorkPlace = true
    if (lastCenter && lastCenter.userId === this.userInfo.id) {
      this.selectCenterId = lastCenter.id
    } else {
      this.selectCenterId = this.centerVos[0]['id']
    }
  }
}
</script>
<style lang="less">
.homePageModal{
  .ant-modal-body{
    max-height: 500px;
    overflow: auto;
  }
}

@media all and (max-width: 767px) {
  .homePageModal{
    padding: 0 5px;
    .ant-modal-body{
      max-height: 300px;
      overflow: auto;
    }
  }
}
</style>